<template>
  <div class="organization-list">
    <BaseContainerSpread>
      <UiPageHeader
        :title="dapLangGlobal.organization"
        :description="{
          ja: 'ジャパンサーチと連携している機関の一覧です。',
          en: 'Organizations connecting their database to the Japan Search',
        }"
        icon="koicon/koicon-18"
      />
    </BaseContainerSpread>

    <BaseContainerSpread
      class="jps-list-card-layout generated-13"
      tag="section"
      v-if="ss.searched"
      :id="ss.state.storeId"
    >
      <div class="search-result-header">
        <div class="is-size-7-touch">
          <p>{{ lst({ ja:'{} 機関', en:'{} organizations' }, ss.state.result?.hit) }}</p>
        </div>
        <SearchPagination :ss="ss" />
        <div class="narrow-search">
          <SearchBoxSimple :ss="ss" :auto="true" />
        </div>
      </div>
      <Transition name="cs-organization">
        <BaseLayoutGrid>
          <div v-for="org in ss.state.result.list" :key="org.id" class="grid-item">
            <UiDataCard type="organization" :data="org" />
          </div>
        </BaseLayoutGrid>
      </Transition>
      <SearchPagination class="footer-paginaition" :ss="ss" :autoscroll="true" />
    </BaseContainerSpread>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  qsearch: true,
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { lst } = useI18n()
const { searchOrganization } = useOrganization()

const ss: SearchStore<Organization> = useSearch<Database>(
  {
    keywordFields: ['keywords'],
    keywordPlaceholder: { ja: '絞り込み', en: 'Filter' },
  },
  searchOrganization,
  {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'P'
      if (!q.filter) q.filter = {}
      q.filter.type = ['NORMAL']
      return q
    }
  }
)
await ss.restoreQuery()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.organization-list {
  padding-top: 3rem;
  @include is-mobile() {
    padding-top: 1rem;
  }
  .jps-list-header {
    @include margin-full-width();
  }
}
.grid-item {
  .jps-card {
    height: 400px;
  }
}
.generated-13 {
    background-color: #fafafa;
}
</style>
